module.exports = __webpack_public_path__ + "img/icmcup.a7ef2444.svg";